export default __webpack_public_path__ + "static/overlay-3fba5f6975280db3a12b008c0e25fde3.png";